import * as Redux from 'redux';
import { IActionCreator } from '../../../interfaces/IActionCreator';
import { Keys } from './types';
import { invokeApi } from '../../../networking/invoker';
import { trainer } from '../../../../model/trainer';

export interface IActions {
    loadTrainers: (fullnameOrEmail?: string, tag?: string) => Promise<Array<trainer>>;
    loadTrainer: (Id: string) => void;
    saveTrainer: (trainer: trainer) => Promise<trainer>;
    createTrainer: () => void;
}



function parseQueryStringParameters(fullnameOrEmail?: string, tag?: string, page?: number, take?: number) {
    let parsed = ``
    if (fullnameOrEmail || tag) {
        parsed = parsed.concat(`?`);
        if (fullnameOrEmail) {
            parsed = parsed.concat(`fullnameOrEmail=${fullnameOrEmail}`);
        }
        if (tag) {
            if (parsed.length > 1) {
                parsed = parsed.concat(`&`);
            }
            parsed = parsed.concat(`tag=${tag}`);
        }
    }
    // if (parsed.length == 0) {
    //     parsed = parsed.concat(`?`);
    // }
    // if (page !== undefined) {
    //     if (parsed.length > 1) {
    //         parsed = parsed.concat(`&`);
    //     }
    //     parsed = parsed.concat(`page=${page}`);
    // }
    // if (take) {
    //     if (parsed.length > 1) {
    //         parsed = parsed.concat(`&`);
    //     }
    //     parsed = parsed.concat(`take=${take}`);
    // }
    return parsed;
}

export const actionCreator: IActionCreator<IActions> = (dispatch: Redux.Dispatch<any>): IActions => {
    return {
        loadTrainers: (fullnameOrEmail?: string, tag?: string) => {
            return new Promise((res, rej) => {
                dispatch({
                    type: Keys.LOADTRAINERS,
                    payload: invokeApi({
                        path: '/api/Trainers' + parseQueryStringParameters(fullnameOrEmail, tag),
                        method: 'GET',
                        responseType: 'json'
                    }).then(resp => {
                        res(resp);
                        return resp;
                    })
                })
            });
        },
        createTrainer: () => {
            dispatch({
                type: Keys.CREATENEWTRAINER
            });
        },
        loadTrainer: (id: string) => {
            dispatch({
                type: Keys.LOADTRAINER,
                payload: invokeApi({
                    path: '/api/Trainers/' + id,
                    method: 'GET',
                    responseType: 'json'
                })
            })
        },
        saveTrainer: (trainer: trainer) => {
            return new Promise((res, rej) =>
                dispatch({
                    type: Keys.SAVETRAINER,
                    payload: invokeApi({
                        path: '/api/Trainers',
                        method: 'POST',
                        body: trainer,
                        responseType: 'json'
                    }).then(resp => {
                        res(resp);
                        return resp;
                    }),
                })
            )
        },
        // userConnected: (sub, connId) => {
        //     dispatch({
        //         type: Keys.USERCONNECTED,
        //         payload: { sub, connId }
        //     })
        // },
        // clearContactSelection: () => {
        //     dispatch({
        //         type: Keys.CLEARSELECTION,
        //     })
        // },
        // userDisconnected: (sub) => {
        //     dispatch({
        //         type: Keys.USERDISCONNECTED,
        //         payload: sub
        //     })
        // },
    }
}